import React from "react"
import { FilePond, registerPlugin } from "react-filepond"
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation"
import FilePondPluginImagePreview from "filepond-plugin-image-preview"
import { Mutation } from "react-apollo"
import PropTypes from "prop-types"
import { createMessage } from "gql/mutations"
import { PHOTO, FILE } from "../messageTypes"

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

const MessageFileUpload = ({ chatRoomId, modal }) => {
  return (
    <Mutation mutation={createMessage}>
      {createMessage => {
        return (
          <FilePond
            labelIdle='將檔案拖拉至此 或 <span class="filepond--label-action">瀏覽檔案</span>'
            allowMultiple={true}
            onupdatefiles={fileItems => {
              modal.setOnSubmit(() => {
                if (fileItems.length === 0) {
                  return
                }

                fileItems.forEach(item => {
                  createMessage({
                    variables: {
                      input: {
                        type:
                          item.file.type.toLowerCase().includes("image/jpeg") ||
                          item.file.type.toLowerCase().includes("image/jpg") ||
                          item.file.type.toLowerCase().includes("image/png")
                            ? PHOTO
                            : FILE,
                        chatRoom: chatRoomId,
                        file: item.file,
                        fileName: item.file.name
                      }
                    }
                  })
                })
              })
            }}
          />
        )
      }}
    </Mutation>
  )
}

MessageFileUpload.propTypes = {
  chatRoomId: PropTypes.string.isRequired,
  modal: PropTypes.object.isRequired
}

export default MessageFileUpload
